import React from 'react';
import Stack from '@mui/material/Stack';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tools from './Toolbar/Tools';
import UndoRedo from './Toolbar/UndoRedo';
import Actions from './Toolbar/Actions';
import View from './Toolbar/View';
import Info from './Toolbar/Info';
import Settings from './Toolbar/Settings';
import InstallPWAButton from './InstallPWAButton';

export default function Toolbar() {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className="toolbar-root"
      sx={{
        position: 'fixed', zIndex: 1, m: 1, backgroundColor: 'background.paper', borderRadius: 1, p: 1, width: 'calc(100% - 16px)',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Tools />
        <UndoRedo />
        <Actions />
        <View />
        <ToggleButtonGroup size="small" sx={{ ml: 1 }}>
          <Info />
          <Settings />
        </ToggleButtonGroup>
        <InstallPWAButton />
      </Stack>
    </Stack>
  );
}
